<template lang="pug">
  .formula(:class="isCompatible()" data-toggle='tooltip' data-placement='right' :title="isCompatibleTooltip()")
    b.mr-1(v-html="label+':'")
    i(v-html="formulaResult.resultString")
    a.float-right(v-b-toggle:[idGenerated] style="cursor: pointer")
      span.when-closed +
      span.when-open -

    b-collapse(:id="idGenerated")
      span(v-html="formulaResult.details").littleText

</template>

<script>
export default {
  name: "formulaResult",
  props: ['pollutanId', 'label', 'formulaResult', 'id_tech', 'allFormulas', 'tech'],
  computed:{
    idGenerated(){
      return this.label+'_'+this.id_tech
    }
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
  },
  methods:{
    isCompatible(){
      if(this.pollutanId === 'bod' && this.tech.c_removal === 'active') return "active"
      if(this.pollutanId === 'cod' && this.tech.c_removal === 'active') return "active"

      // if(this.pollutanId === 'tn' && (this.tech.n_removal_nitrateremoval === 'active' || this.tech.n_removal_nitrification === 'active')) return "active"

      // if(this.pollutanId === 'no3' && this.tech.n_removal_nitrateremoval === 'active') return "active"
      // if(this.pollutanId === 'nh4' && this.tech.n_removal_nitrification === 'active') return "active"
      if(['tn', 'no3'].includes(this.pollutanId) && this.tech.n_removal_nitrateremoval === 'active') return "active"
      if(['tn', 'nh4'].includes(this.pollutanId) && this.tech.n_removal_nitrification === 'active') return "active"

      // if((this.pollutanId === 'po43') && this.tech.p_removal === 'active') return "active"
      if(['tp', 'po43'].includes(this.pollutanId) && this.tech.p_removal === 'active') return "active"

      if(this.pollutanId === 'ecoli') return "active"
      if(this.pollutanId === 'heggs') return "active"

      else return "inactive"
    },
    isCompatibleTooltip(){

      let textTooltip = "If the NBS is not designed for removing a specific contaminant (grey values), the estimated area to remove it might be dramatically high or low."

      if(this.pollutanId === 'bod' && this.tech.c_removal === 'active') return ""
      if(this.pollutanId === 'cod' && this.tech.c_removal === 'active') return ""

      if(this.pollutanId === 'no3' && this.tech.n_removal_nitrateremoval === 'active') return ""
      if(this.pollutanId === 'nh4' && this.tech.n_removal_nitrification === 'active') return ""

      if(this.pollutanId === 'po43' && this.tech.p_removal === 'active') return ""

      if(this.pollutanId === 'ecoli') return ""
      if(this.pollutanId === 'heggs') return ""

      else return textTooltip
    }
  }
}
</script>

<style scoped>
  .littleText{
    font-size: 12px;
  }

  .collapsed > .when-open,
  .not-collapsed > .when-closed {
    display: none;
  }

  .formula.inactive {
    color: lightgray;
  }
</style>